import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { mainCourses } from '@/mocks/seminarData';
import { formatPrice } from '@/lib/formatPrice';

const COURSE_COUNT = 3;

export default function CourseIntro() {
  const { t } = useTranslation();
  return (
    <section className="relative py-20 md:py-28 bg-background-100">
      <div className="max-w-[1600px] mx-auto px-8 md:px-12 lg:px-16">
        <div className="text-center mb-12">
          <p className="text-accent-600 text-[13px] tracking-[0.2em] mb-5 font-label">
            MAIN COURSES
          </p>
          <h2 className="font-heading text-xl md:text-2xl text-foreground-900 tracking-[0.06em] mb-4">
            {t('seminar.courses.altTitle')}
          </h2>
          <div className="gold-line mx-auto"></div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
          {Array.from({ length: COURSE_COUNT }, (_, index) => (
            <Link
              key={index}
              to={mainCourses[index].href}
              className="card-glow bg-background-50 border border-background-200/60 p-6 group cursor-pointer flex flex-col"
            >
              <p className="text-[12px] text-accent-500/60 tracking-[0.15em] mb-2 font-label">
                {mainCourses[index].nameEn}
              </p>
              <h4 className="font-heading text-[17px] text-foreground-900 tracking-[0.06em] mb-2 group-hover:text-accent-600 transition-colors duration-300">
                {t(`seminar.courses.${index}.name`)}
              </h4>
              <p className="text-[14px] text-foreground-500 tracking-[0.04em] mb-3">
                {t(`seminar.courses.${index}.duration`)}
              </p>
              <p className="text-[15px] text-foreground-600 leading-relaxed tracking-[0.03em] mb-4 flex-1">
                {t(`seminar.courses.${index}.description`)}
              </p>
              <div className="flex items-center justify-between">
                <span className="text-[17px] text-accent-700 font-medium tracking-[0.04em] font-label">
                  ¥{formatPrice(mainCourses[index].price)}<span className="text-[13px] text-foreground-500">{t('seminar.courses.taxLabel')}</span>
                </span>
                <span className="inline-flex items-center gap-1 text-[13px] text-accent-600 tracking-[0.08em]">
                  <span>{t('seminar.courses.viewDetail')}</span>
                  <i className="ri-arrow-right-line text-[12px] transition-transform duration-300 group-hover:translate-x-1"></i>
                </span>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}
